import Headertop from './../Headers/index.vue'


export default {
  name: 'ethertest',
  props: [],
  components: { Headertop },
  mounted() {

  },
  data() {
    return {
      email: '',
      showsend: true,
      showclaim: false,
      activeTab: 'send'
    }
  },
  methods: {
    showSend(){
      this.showsend = true;
      this.showclaim = false;
      this.activeTab = 'send';
      var address = web3.eth.defaultAccount
      console.log("window.tokenmain")
      console.log(window.tokenmain)
      //var balance = web3.eth.getBalance(address);
            console.log("address")
            console.log(address)
      this.getBalance(address);
    },
    getBalance(address){
      console.log("getBalance")
      //var address2 = web3.eth.defaultAccount;
      web3.eth.getBalance(address,(err, data) => {
          console.log("data balance ")
          console.log(data)
          console.log(data.toString(10))
      });
    },
    showClaim(){
      this.showsend = false;
      this.showclaim = true;
      this.activeTab = 'claim';

    },
    send(){

      web3.eth.contract(token.contractABI).at(token.contractAddress).transfer(
        document.getElementById("input-recipient").value,
        document.getElementById("input-amount").value,
        function (error, result) {
          if ( ! error) {


            App.drawItem('Send', 'https://ropsten.etherscan.io/tx/' + result, result).toStorage();
          } else {
            App.drawItem('Send', '#send', error.message.split('\n')[0])
          }
      })
    },
    claim(){
      web3.eth.contract(token.contractABI).at(token.contractAddress).claim(
      function (error, result) {
        if ( ! error) {
          App.drawItem('Claim', 'https://ropsten.etherscan.io/tx/' + result, result).toStorage()
        } else {
          App.drawItem('Claim', '#claim', error.message.split('\n')[0])
        }
      })
    }
  },
  computed: {

  },
  beforeCreate() {

  },
  created() {

    window.token = {
      contractAddress: '0xfdbef055ede762a7e3e3f33b3146cee3499b5192', // Claimable Token
      contractABI: JSON.parse('[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"claim","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"version","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"remaining","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[{"name":"_initialAmount","type":"uint256"},{"name":"_tokenName","type":"string"},{"name":"_decimalUnits","type":"uint8"},{"name":"_tokenSymbol","type":"string"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_from","type":"address"},{"indexed":true,"name":"_to","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_owner","type":"address"},{"indexed":true,"name":"_spender","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Approval","type":"event"}]')
    }

      window.App = window.App || {}
      var items = []

      window.template = {
        txItem: function (params) {
          return `<div class="tile tile-centered" style="margin-top: 15px">
                    <div class="tile-content">
                      <div class="tile-title">${ params.title }</div>
                      <a href="${ params.url }" class="tile-subtitle">${ params.subtitle }</a>
                    </div>
                  </div>`
        },

        errorLabel: function (params) {
          return `<span class="label label-error text-center d-block">${ params.text }</span>`
        },

        forkMe: function (params) {
          // https://github.com/tholman/github-corners
          return `<a href="${ params.url }" class="github-corner" aria-label="View source on Github"><svg width="120" height="120" viewBox="0 0 250 250" style="fill:#5764c6; color:#fff; position: absolute; top: 0; border: 0; right: 0;" aria-hidden="true"><path d="M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z"></path><path d="M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2" fill="currentColor" style="transform-origin: 130px 106px;" class="octo-arm"></path><path d="M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z" fill="currentColor" class="octo-body"></path></svg></a><style>.github-corner:hover .octo-arm{animation:octocat-wave 560ms ease-in-out}@keyframes octocat-wave{0%,100%{transform:rotate(0)}20%,60%{transform:rotate(-25deg)}40%,80%{transform:rotate(10deg)}}@media (max-width:500px){.github-corner:hover .octo-arm{animation:none}.github-corner .octo-arm{animation:octocat-wave 560ms ease-in-out}}</style>`
        }
      }

      App.restoreItemsFromStorage = function () {
        console.log("restoreItemsFromStorage = function------1")
        items = JSON.parse(localStorage.getItem('items')) || []
        items.forEach(function (item) {
          App.drawItem(item.title, item.url, item.subtitle)
        });
      }

      App.drawItem = function (title, url, subtitle) {
          var item = {
            title: title,
            url: url,
            subtitle: subtitle
          }
          document.getElementById('tx-list').innerHTML += template.txItem(item)
          console.log("template.txItem(item)------2")
          console.log(template.txItem(item))
          return {
            toStorage: function () {
              items.push(item)
              localStorage.setItem('items', JSON.stringify(items))
            }
          }
        }


    window.addEventListener('load', function () {
       console.log("web3 ------1")
        console.log(web3)
      App.restoreItemsFromStorage()
      if (typeof web3 !== 'undefined') {
        window.web3 = new Web3(web3.currentProvider)
        web3.net.getListening( function(error, result) {
          if( ! error && result) {
            if(typeof web3.eth.defaultAccount !== 'undefined') {
              //document.getElementById('input-claim').value = web3.eth.defaultAccount
            } else {
              console.log('Please unlock Metamask and refresh the page!');
              showError('Please unlock Metamask and refresh the page!')
            }
          }
        })
      } else {
        console.log('Please unlock Metamask and refresh the page!');
        showError('Please use Chrome, install Metamask and then try again!')
      }

      function showError (msg) {
        console.log("showError function tut")
        document.getElementById('error-label').innerHTML = template.errorLabel({ text: msg })
        document.getElementById('btn-send').disabled = true
        //ocument.getElementById('btn-claim').disabled = true
      }
    });

  }
}



// WEBPACK FOOTER //
// ./src/components/Ethertest/Ethertest.component.js